import { all, call, put, takeLatest } from "redux-saga/effects";
import * as actionType from "../constants/action_types";
import * as actions from "../actions/index";
import { axiosGet } from "../util/axios";

function* getActivities(action) {
  try {
    if (action.payload.page === 1) {
      yield put(
        actions.RESET_STATE("activity.activites", {
          data: [],
          current_page: 1,
          total_pages: null,
        })
      );
    }
    const url = `/activity`;
    const params = { ...action.payload };
    let { data, status } = yield call(axiosGet, url, { params });
    yield put(
      actions.GETACTIVITY_RESPONSE({
        ...data,
        status,
        limit: action.payload.limit,
      })
    );
  } catch (error) {
    yield put(actions.GETACTIVITY_RESPONSE(error));
  }
}

function* activityWatcherSaga() {
  yield all([takeLatest(actionType.GETACTIVITY_REQ, getActivities)]);
}

export default activityWatcherSaga;
